import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "antd";
import SponsorOrphanCard from "../../../../biblio/Cards/SponsorOrphanCard";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../../../components/utils/utils";
import SponsorResult from "./SponsorResult";
import { addOrUpdateItem, removeItem } from "./utils";
import SponsorDonation from "./SponsorDonation";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getMyOrphansNeeds } from "../../../../apis/actions/sponsor.actions";

interface PropsSponsorOrphanCard {
  data?: any;
  mobile: string;
}

const OurSponsorOrphans = ({ data, mobile }: PropsSponsorOrphanCard) => {
  const currentRef = useRef<HTMLDivElement>(null);
  const [items, setItems] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch<AppDispatch>();
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);

  const { myOrphansNeeds, TotalMyOrphansNeeds, loading } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const sortedData =
    myOrphansNeeds &&
    myOrphansNeeds
      .map((item: any) => item)
      .sort((a: any, b: any) => a.sequence - b.sequence);

  const itemPerPage = 4;

  useEffect(() => {
    dispatch(
      getMyOrphansNeeds({
        limit: itemPerPage,
        page: currentPage,
        sponsor_id: OtpId,
      })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  if (loading) {
    return (
      <div className="takaful--loading-projects-cases">
        <p className="takaful--no-project-message"> جارٍ التحميل</p>
        <DotsLoader />
      </div>
    );
  }

  return (
    <>
      <SponsorResult items={items} />
      {sortedData && sortedData.length === 0 ? (
        <p className="takaful--no-services">لا توجد أيتام أو أرامل</p>
      ) : (
        <>
          <Row dir="rtl" gutter={[16, 16]}>
            {sortedData &&
              sortedData.map((item: any, index: number) => (
                <Col
                  key={index}
                  xxl={12}
                  xl={12}
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                >
                  <SponsorOrphanCard
                    removeValue={(item) =>
                      setItems(removeItem(item, [...items]))
                    }
                    updateValue={(item) =>
                      setItems(addOrUpdateItem(item, [...items]))
                    }
                    key={index}
                    data={item}
                    defaultItem={
                      items.filter(
                        (el) => el.beneficiary_service_request_id === item.id
                      )[0] ?? null
                    }
                  />
                </Col>
              ))}
          </Row>

          <div className="takaful--pagination-container">
            {sortedData &&
              Math.ceil(TotalMyOrphansNeeds * itemPerPage) > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalMyOrphansNeeds * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
          <SponsorDonation items={items} mobile={mobile} />
        </>
      )}
    </>
  );
};

export default OurSponsorOrphans;
